import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CustomHttpInterceptor } from './interceptors/custom-http.interceptor';
import { CommonModule } from '@angular/common';
import { ImageCropperModule } from 'ngx-image-cropper';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormateDatePipe } from './pipes/formate-date.pipe';
import { LoginComponent } from './login/login.component';
import { AdminLoginComponent } from './admin-login/admin-login.component';
import { NotAuthHeaderComponent } from './not-auth-header/not-auth-header.component';
import { AdminDashboardComponent } from './admin-dashboard/admin-dashboard.component';
import { UserHomeComponent } from './user-home/user-home.component';
import { ActivateUserComponent } from './activate-user/activate-user.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { UserHeaderComponent } from './user-header/user-header.component';
import { CompanyDetailsComponent } from './company-details/company-details.component';
import { UserDetailsComponent } from './user-details/user-details.component';
import { RegisterUserComponent } from './register-user/register-user.component';
import { EditCompanyComponent } from './edit-company/edit-company.component';
import { OrderComponent } from './order/order.component';
import { SelectBusinessComponent } from './select-business/select-business.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { OpeningsComponent } from './openings/openings.component';
import { AddOpeningComponent } from './add-opening/add-opening.component';
import { AddSubgroupComponent } from './add-subgroup/add-subgroup.component';
import { SingleOpeningComponent } from './single-opening/single-opening.component';
import { ProfileOpenedComponent } from './profile-opened/profile-opened.component';
import { CompanyBillingComponent } from './company-billing/company-billing.component';
import { PoolComponent } from './pool/pool.component';
import { MessagesComponent } from './messages/messages.component';
import { MarketpalceComponent } from './marketpalce/marketpalce.component';
import { HeadhuntingComponent } from './headhunting/headhunting.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { SingleMarketplaceComponent } from './single-marketplace/single-marketplace.component';
import { WishlistsComponent } from './wishlists/wishlists.component';
import { SingleWishlistComponent } from './single-wishlist/single-wishlist.component';
import { GenerateDatesPipe } from './pipes/generate-dates.pipe';
import { AdminSidebarComponent } from './admin-sidebar/admin-sidebar.component';
import { AdminAddCompanyComponent } from './admin-add-company/admin-add-company.component';
import { AdminCompaniesComponent } from './admin-companies/admin-companies.component';
import { AdminCompanyBillingComponent } from './admin-company-billing/admin-company-billing.component';
import { AdminUsersComponent } from './admin-users/admin-users.component';
import { AdminUserDetailsComponent } from './admin-user-details/admin-user-details.component';
import { AdminCompanyDetailsComponent } from './admin-company-details/admin-company-details.component';
import { AdminCompanyPricingComponent } from './admin-company-pricing/admin-company-pricing.component';
import { AdminOpeningsComponent } from './admin-openings/admin-openings.component';
import { AdminParamsComponent } from './admin-params/admin-params.component';
import { AdminSingleParamComponent } from './admin-single-param/admin-single-param.component';
import { AdminOpeningDetailsComponent } from './admin-opening-details/admin-opening-details.component';
import { MessageComponent } from './message/message.component';
import { TruncatePipe } from './pipes/truncate.pipe';
import { AddMarketplaceComponent } from './add-marketplace/add-marketplace.component';
import { ValidateMobileUserComponent } from './validate-mobile-user/validate-mobile-user.component';
import { FormateMessageDatePipePipe } from './pipes/formate-message-date-pipe.pipe';
import { ChatTimeIndicatorPipe } from './pipes/chat-time-indicator.pipe';
import { TopBannerComponent } from './top-banner/top-banner.component';
import { ForumComponent } from './forum/forum.component';
import { ForumSingleTopicComponent } from './forum-single-topic/forum-single-topic.component';
import { GenerateAvatarImageURLPipe } from './pipes/generate-avatar-image-url.pipe';
import { MdTypePipe } from './pipes/md-type.pipe';
import { WorkpossibilityPipe } from './pipes/workpossibility.pipe';
import { FormateDateMonthPipe } from './pipes/formate-date-month.pipe';
import { PubOpeningsComponent } from './pub-openings/pub-openings.component';
import { PubOpeningComponent } from './pub-opening/pub-opening.component';
import { StudenttypePipe } from './pipes/studenttype.pipe';
import { AdminCooperationCodesComponent } from './admin-cooperation-codes/admin-cooperation-codes.component';
import { AdminTranslationsComponent } from './admin-translations/admin-translations.component';
import { AdminConsumerProductsComponent } from './admin-consumer-products/admin-consumer-products.component';
import { CompanyRegisterComponent } from './company-register/company-register.component';
import { AdminValidateCompanyComponent } from './admin-validate-company/admin-validate-company.component';
import { CompanyInterestsComponent } from './company-interests/company-interests.component';
import { AdminSkillsComponent } from './admin-skills/admin-skills.component';
import { AdminJobtitlesComponent } from './admin-jobtitles/admin-jobtitles.component';
import { AdminSchoolsComponent } from './admin-schools/admin-schools.component';
import { AdminArticlesComponent } from './admin-articles/admin-articles.component';
import { WorktimesPipe } from './pipes/worktimes.pipe';
import { SingleEmployerListComponent } from './single-employer-list/single-employer-list.component';
import { EmployerListsComponent } from './employer-lists/employer-lists.component';
import { SearchAlertsComponent } from './search-alerts/search-alerts.component';
import { SingleSearchAlertComponent } from './single-search-alert/single-search-alert.component';

@NgModule({ declarations: [
        AppComponent,
        FormateDatePipe,
        LoginComponent,
        CompanyInterestsComponent,
        AdminLoginComponent,
        NotAuthHeaderComponent,
        AdminDashboardComponent,
        AdminValidateCompanyComponent,
        UserHomeComponent,
        ActivateUserComponent,
        ForgotPasswordComponent,
        ResetPasswordComponent,
        UserHeaderComponent,
        CompanyDetailsComponent,
        UserDetailsComponent,
        RegisterUserComponent,
        EditCompanyComponent,
        OrderComponent,
        SelectBusinessComponent,
        OpeningsComponent,
        AddOpeningComponent,
        AddSubgroupComponent,
        SingleOpeningComponent,
        ProfileOpenedComponent,
        CompanyBillingComponent,
        CompanyRegisterComponent,
        PoolComponent,
        TruncatePipe,
        MessagesComponent,
        MarketpalceComponent,
        HeadhuntingComponent,
        SidebarComponent,
        SingleMarketplaceComponent,
        WishlistsComponent,
        SingleWishlistComponent,
        GenerateDatesPipe,
        AdminAddCompanyComponent,
        AdminCompaniesComponent,
        AdminCompanyBillingComponent,
        AdminUsersComponent,
        AdminUserDetailsComponent,
        AdminCompanyDetailsComponent,
        AdminCompanyPricingComponent,
        AdminOpeningsComponent,
        AdminParamsComponent,
        AdminSingleParamComponent,
        AdminOpeningDetailsComponent,
        AdminSidebarComponent,
        AdminTranslationsComponent,
        AdminConsumerProductsComponent,
        MessageComponent,
        AddMarketplaceComponent,
        ValidateMobileUserComponent,
        FormateMessageDatePipePipe,
        ChatTimeIndicatorPipe,
        TopBannerComponent,
        ForumComponent,
        ForumSingleTopicComponent,
        GenerateAvatarImageURLPipe,
        MdTypePipe,
        WorkpossibilityPipe,
        WorktimesPipe,
        FormateDateMonthPipe,
        PubOpeningsComponent,
        PubOpeningComponent,
        StudenttypePipe,
        AdminCooperationCodesComponent,
        AdminSkillsComponent,
        AdminJobtitlesComponent,
        AdminSidebarComponent,
        AdminSchoolsComponent,
        AdminArticlesComponent,
        SingleEmployerListComponent,
        EmployerListsComponent,
        SearchAlertsComponent,
        SingleSearchAlertComponent,

    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        FormsModule,
        AppRoutingModule,
        ReactiveFormsModule,
        CommonModule,
        BrowserAnimationsModule,
        ImageCropperModule], providers: [
        CustomHttpInterceptor,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: CustomHttpInterceptor,
            multi: true
        },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
